import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { Products } from './components/products';
import { ProductsFilterPage } from './components/productsFilterPage';
import { productsPaths } from './productsPaths';

export const productsRoutes = [
  {
    path: `${productsPaths.root}/*`,
    element: <Products />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/filters`,
    element: <ProductsFilterPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
